export enum ResponseAnswer {
  Yes = 1,
  No = 2,
  NA = 3,
}
